import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CloudStorage from "../../CloudStorage/CloudStorage";

export default function MembershipModel({ setModal, errorMessage, checkpermission }) {
  const path = "Assets/scss/postproject.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  return (
    <>
      <button onClick={() => { setModal(false); }} className="btn close-button">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Upgrade your account</h4>
        {errorMessage ? <p>{errorMessage?.message}</p> : <p>
          Please purchase a membership to create posts and access exclusive
          features.
        </p>}
      </ModalBody>
      <div className="modal-footer mt-3">
        <button
          className="btn"
          onClick={() => {
            setModal((state) => !state);
            navigate(`/${lan}/account/upgrademembership`, { state: { mtype: errorMessage?.mtype || 1, checkpermission: checkpermission } });
          }}
        >
          Buy Membership
        </button>
      </div >
    </>
  );
}
